/* Tiroir de panier « façon Rue des Peignoirs » — thèmes FullStack (2026-11-02).
   La carte « Va bien avec » :
   1. menu de variante : le prix suit l'option choisie ; tant que rien n'est choisi, le « + » n'ajoute rien
      et la carte le dit (jamais de taille choisie d'office) ;
   2. « + » : /cart/add.js avec le rendu de la section du tiroir, puis CartUpdatedEvent — le même chemin que
      cart-drawer.js quand on change une quantité : le tiroir se redessine sans recharger la page, la pastille suit.
   Écouteurs délégués sur document, posés une seule fois : ils survivent au redessin du tiroir. */
import { CartUpdatedEvent } from '@theme/events';

if (!window.__rdpPanier) {
  window.__rdpPanier = true;

  const message = (carte, texte) => {
    const m = carte.querySelector('.rp-duo__msg');
    if (!m) return;
    m.textContent = texte || '';
    m.hidden = !texte;
  };

  document.addEventListener('change', (e) => {
    const s = e.target;
    if (!(s instanceof HTMLSelectElement) || !s.matches('[data-rp-var]')) return;
    const carte = s.closest('[data-rp-duo]');
    if (!carte) return;
    s.classList.remove('is-a-choisir');
    message(carte, '');
    const opt = s.selectedOptions[0];
    const prix = carte.querySelector('[data-rp-prix]');
    if (prix && opt && opt.dataset.prix) prix.innerHTML = `<b>${opt.dataset.prix}</b>`;
  });

  document.addEventListener('click', async (e) => {
    const b = e.target instanceof Element ? e.target.closest('[data-rp-ajout]') : null;
    if (!b || b.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    const carte = b.closest('[data-rp-duo]');
    const champ = carte && carte.querySelector('[data-rp-var]');
    const id = champ ? champ.value : '';
    if (!id) {
      if (champ instanceof HTMLSelectElement) { champ.classList.add('is-a-choisir'); champ.focus(); }
      message(carte, carte.dataset.choisir || 'Choisissez d’abord une option.');
      return;
    }
    const tiroir = b.closest('cart-drawer') || document.querySelector('cart-drawer');
    const section = tiroir && tiroir.dataset.sectionId ? tiroir.dataset.sectionId : '';
    b.setAttribute('aria-busy', 'true');
    try {
      const url = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add';
      const r = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: section, sections_url: window.location.pathname }),
      });
      const rep = await r.json();
      if (!r.ok || rep.status) throw new Error(rep.description || rep.message || 'Ajout impossible');
      const panier = await (await fetch(((window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart') + '.js', { headers: { Accept: 'application/json' } })).json();
      document.dispatchEvent(new CartUpdatedEvent({}, { itemCount: panier.item_count, source: 'rdp-duo', sections: rep.sections }));
    } catch (err) {
      b.removeAttribute('aria-busy');
      message(carte, String((err && err.message) || err));
    }
  });
}
